"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.tableCellPropDefs = exports.tableRowPropDefs = exports.tableRootPropDefs = void 0;
const index_js_1 = require("../helpers/index.js");
const sizes = ['1', '2', '3'];
const variants = ['surface', 'ghost'];
const layoutValues = ['auto', 'fixed'];
const tableRootPropDefs = {
    size: {
        type: 'enum',
        className: 'rt-r-size',
        values: sizes,
        default: '2',
        responsive: true,
    },
    variant: {
        type: 'enum',
        className: 'rt-variant',
        values: variants,
        default: 'ghost',
    },
    layout: {
        type: 'enum',
        className: 'rt-r-tl',
        values: layoutValues,
        default: undefined,
        responsive: true,
    },
};
exports.tableRootPropDefs = tableRootPropDefs;
const rowAlign = ['start', 'center', 'end', 'baseline'];
const tableRowPropDefs = {
    align: {
        type: 'enum',
        className: 'rt-r-va',
        values: rowAlign,
        parseValue: parseAlignValue,
        default: undefined,
        responsive: true,
    },
};
exports.tableRowPropDefs = tableRowPropDefs;
function parseAlignValue(value) {
    return {
        baseline: 'baseline',
        start: 'top',
        center: 'middle',
        end: 'bottom',
    }[value];
}
const justifyValues = ['start', 'center', 'end'];
const tableCellPropDefs = {
    justify: {
        type: 'enum',
        className: 'rt-r-ta',
        values: justifyValues,
        parseValue: parseJustifyValue,
        default: undefined,
        responsive: true,
    },
    ...index_js_1.widthPropDefs,
    ...index_js_1.paddingPropDefs,
};
exports.tableCellPropDefs = tableCellPropDefs;
function parseJustifyValue(value) {
    return {
        start: 'left',
        center: 'center',
        end: 'right',
    }[value];
}
//# sourceMappingURL=table.props.js.map